import React from 'react';

import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';



const DropdownIconBuilder: IconBuilder = {
	icon: ({ color = '#4383CC' }) => {
		return (
			<g
				fill="none"
				fillRule="evenodd"
				id="Page-1"
				stroke="none"
				strokeWidth="1"
			>
				<path
					clipRule="evenodd"
					d="M9.8509 3.568C10.0499 3.379 10.0499 3.072 9.8509 2.884L9.1339 2.201C8.9369 2.011 8.6169 2.011 8.4189 2.201L5.0149 5.496L1.5809 2.173C1.3819 1.984 1.0619 1.984 0.864903 2.173L0.147903 2.857C-0.0490974 3.045 -0.0490974 3.351 0.147903 3.541L4.6559 7.89C4.8549 8.078 5.1749 8.078 5.3719 7.89L9.8509 3.568Z"
					fill={color}
					fillRule="evenodd"
					id="dropdown-arrow"
				/>
			</g>
		);
	},
	viewBoxHeight: 10,
	viewBoxWidth: 10,
};



export default DropdownIconBuilder;
